import { useEffect, useRef } from 'react';
import { Dimensions, useWindowDimensions } from 'react-native';
import { BackHandler } from 'react-native';
import { User } from '../typesAndInterfaces/typesAndInterfaces';
import { getUserAccess } from '../utils/access';
const utilHooks = {
    useWidthChange: (isActive: boolean, callBack: () => void) => {
        const dims = useWindowDimensions();
        const windowWidth = useRef(dims.width);

        // We need to set the width when window gets activated, otherwise if you change the window width and
        // then mount this, callback will get called.
        useEffect(() => {
            if (isActive) {
                windowWidth.current = Dimensions.get('window').width;
            }
        }, [isActive]);

        useEffect(() => {
            if (!isActive) {
                return;
            }

            if (dims.width !== windowWidth.current) {
                callBack();
                windowWidth.current = dims.width;
            }
        }, [callBack, dims.width, isActive]);
    },

    useAndroidBackButton: (backButtonAction: () => void) => {
        useEffect(() => {
            const handleBackButton = () => {
                backButtonAction();
                return true;
            };
            const subscription = BackHandler.addEventListener('hardwareBackPress', handleBackButton);
            return () => subscription.remove();
        }, [backButtonAction]);
    },

    useGetAccess: (user?: User) => getUserAccess(user),
};

export { utilHooks };
